import { createSlice } from "@reduxjs/toolkit";

import * as API from "../config/api";
import { ApiRest } from "react-comun-seps/lib/api/ApiRest";
import axios from "axios";

const initialState = {
  listaSolicitudes: {},
  solicitudDetalle: {},
  listaTiposEntidad: {},
  listaTiposIdentificacion: {},
  listaPeriodos: {},
  listadoSocios: {},
  validarDatos: {},
  datos: {},
  datosSocio: {},
  messageSuccess: "",
  messageError: "",
  nombres: {},
  listaCargoControl: {},
  listaCargoDirectivo: {},
  listadoDirectiva: {},
  validarDatosDirectiva: {},
  documentBase64: {},
  previsualizador: {},
};

export const validarSlice = createSlice({
  name: "validarSlice",
  initialState,
  reducers: {
    setSolicitudes: (state, action) => {
      state.listaSolicitudes = action.payload;
    },
    setTipoIdentificacion: (state, action) => {
      state.listaTiposIdentificacion = action.payload;
    },
    setValidarDatos: (state, action) => {
      state.validarDatos = action.payload;
    },
    setDatos: (state, action) => {
      state.datos = action.payload;
    },
    setMessageSuccess: (state, action) => {
      state.messageSuccess = action.payload;
    },
    setMessageError: (state, action) => {
      state.messageError = action.payload;
    },
    setSolicitudDetalle: (state, action) => {
      state.solicitudDetalle = action.payload;
    },
    setTiposEntidad: (state, action) => {
      state.listaTiposEntidad = action.payload;
    },
    setPeriodos: (state, action) => {
      state.listaPeriodos = action.payload;
    },
    setListadoSocios: (state, action) => {
      state.listadoSocios = action.payload;
    },
    setNombres: (state, action) => {
      state.nombres = action.payload;
    },
    setDatosSocio: (state, action) => {
      state.datosSocio = action.payload;
    },
    setListaCargoControl: (state, action) => {
      state.listaCargoControl = action.payload;
    },
    setListaCargoDirectivo: (state, action) => {
      state.listaCargoDirectivo = action.payload;
    },
    setListadoDirectiva: (state, action) => {
      state.listadoDirectiva = action.payload;
    },
    setValidarDirectiva: (state, action) => {
      state.validarDatosDirectiva = action.payload;
    },
    setDocumentBase64: (state, action) => {
      state.documentBase64 = action.payload;
    },
    setPrevisualizador: (state, action) => {
      state.previsualizador = action.payload;
    },
  },
});

export const {
  setSolicitudes,
  setMessageSuccess,
  setMessageError,
  setTipoIdentificacion,
  setListaCatalogosGrupo,
  setListaCatalogosGrupoYCodPadre,
  setValidarDatos,
  setDatos,
  setSolicitudDetalle,
  setTiposEntidad,
  setPeriodos,
  setListadoSocios,
  setNombres,
  setDatosSocio,
  setListaCargoControl,
  setListaCargoDirectivo,
  setListadoDirectiva,
  setValidarDirectiva,
  setDocumentBase64,
  setPrevisualizador,
} = validarSlice.actions;

export const obtenerSolicitudes = (codSolReservDeno) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_GET_SOLICITUDES_CONSTITUCION}?codSolReservDeno=${codSolReservDeno}`
    );
    dispatch(setSolicitudes(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerSolicitudDetalle = (idSolReservaDenominacion) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_GET_SOLICITUD_DETALLE}?idSolReservaDenominacion=${idSolReservaDenominacion}`
    );
    dispatch(setSolicitudDetalle(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const validarRuc = (identificaion) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_POST_RUC}?tipoIdentificacion=R&identificacion=${identificaion}`
    );
    dispatch(setDatos(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerTiposEntidad = (idTipoSolicitud) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_GET_TIPOS_ENTIDAD}?idTipoSolicitud=${idTipoSolicitud}`
    );
    dispatch(setTiposEntidad(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerPeriodos = (idTipoSolicitud) => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_GET_PERIODOS}`);
    dispatch(setPeriodos(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const validarDatosReserva = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_POST_VALIDAR_DATOS}`, data);
    dispatch(setValidarDatos(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerDetalleEntidad = (codSolReservDeno, codSolConstitucion) => async (dispatch) => {
  try {
    let param = "?codSolReservDeno=" + codSolReservDeno;
    if (codSolConstitucion) {
      param = param + "&codSolConstitucion=" + codSolConstitucion;
    }
    const result = await ApiRest.get(`${API.URL_GET_SOLICITUD_DETALLE_CONSTITUCION}${param}`);
    dispatch(setValidarDatos(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerSocios = (codSolConstitucion) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_GET_SOCIOS}?codSolConstitucion=${codSolConstitucion}`
    );
    dispatch(setListadoSocios(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const gurdarDatosEntidad = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_POST_GUARDAR_DATOS_ENTIDAD}`, data);
    dispatch(setValidarDatos(result.data));
    dispatch(setMessageSuccess(result.data.message));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const guardarSocio = (data) => async (dispatch) => {
  try {
    const requestOptions = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const result = await axios.post(`${API.URL_GUARDAR_SOCIO}`, data, requestOptions);
    dispatch(setMessageSuccess(result.data.message));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const eliminarSocio = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.put(`${API.URL_ELIMINAR_SOCIO}`, data);
    dispatch(setMessageSuccess(result.data.message));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerNombres = (identificacion) => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_GET_NOMBRES}?identificacion=${identificacion}`);
    dispatch(setNombres(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerNombresFecha = (tipo, identificacion) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_GET_NOMBRES_FECHA}?tipoIdentificacion=${tipo}&identificacion=${identificacion}`
    );
    dispatch(setNombres(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerSocio = (codSolConsSocio) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_GET_DATOS_SOCIO}?codSolConsSocio=${codSolConsSocio}`
    );
    dispatch(setDatosSocio(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerDirectiva = (codSolConsSocio, grupoConstAdec) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_GET_DATOS_DIRECTIVA}?codSolicitud=${codSolConsSocio}&grupoConstAdec=${grupoConstAdec}`
    );
    dispatch(setListadoDirectiva(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerCargoControl = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_GET_CARGOS_GOBIERNO}`, data);
    dispatch(setListaCargoControl(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const asignarCargo = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_GUARDAR_CARGO}`, data);
    dispatch(setMessageSuccess(result.data.message));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const guardarDirectiva = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_GUARDAR_DIRECTIVA}`, data);
    dispatch(setMessageSuccess(result.data.message));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const validarDirectiva = (codSolicitud, grupoConstAdec) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_VALIDAR_DIRECTIVA}?codSolicitud=${codSolicitud}&grupoConstAdec=${grupoConstAdec}`
    );
    dispatch(setValidarDirectiva(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const guardarOficialCumplimiento = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_GUARDAR_OFICIAL_CUMPLIMIENTO}`, data);
    dispatch(setMessageSuccess(result.data.message));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerOficialCumplimiento = (codSolConst) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_GET_OFICIAL_CUMPLIMIENTO}?codSolConst=${codSolConst}`
    );
    dispatch(setDatos(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const descargarDocumentoDocuware = (codDocuwarePlanilla) => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_GET_CROQUIS}?idSolicitud=${codDocuwarePlanilla}`);
    dispatch(setDocumentBase64(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const descargarPrevisualizador = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_GET_PREVISUALIZADOR}`, data);
    dispatch(setPrevisualizador(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const enviarReserva = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_ENVIAR_RESERVA}`, data);
    dispatch(setMessageSuccess(result.data?.message));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const eliminarCargo = (codConstSociosCargo) => async (dispatch) => {
  try {
    const result = await ApiRest.put(
      `${API.URL_ELIMINAR_CARGO}?codConstSociosCargo=${codConstSociosCargo}`
    );
    dispatch(setMessageSuccess(result.data?.message));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const validarSolicitudExistente = (codSolReservDeno) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_VALIDAR_SOLICITUD_EXISTENTE}?codSolReservDeno=${codSolReservDeno}`
    );
    dispatch(setSolicitudDetalle(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const archivarSolicitud = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_ARCHIVAR_SOLICITUD_EXISTENTE}`, data);
    dispatch(setMessageSuccess(result.data?.message));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

function handleException(exception, dispatch) {
  if (typeof exception === "string") {
    dispatch(setMessageError(exception));
  } else {
    dispatch(setMessageError(exception.data?.message || exception.data));
  }
}

export default validarSlice.reducer;
